const Workspace = (x) => `${x}`;

export const homeCareAppUrl = () => Workspace(`/`);

export const adminsCareAppUrl = () => Workspace(`/admins`);

export const trainersCareAppUrl = () => Workspace(`/trainers`);

export const patientsCareAppUrl = () => Workspace("/patients-all");
export const patientsMineCareAppUrl = () => Workspace("/my-patients");

// export const patientsDocumentsUrl = (patient) =>
//   Workspace(`/p/${patient}/documents`);
// export const patientsSittingsUrl = (patient) =>
//   Workspace(`/p/${patient}/sittings`);
